import { ReduxState } from 'services/types';

export const language = (state: ReduxState) => state.lang;
